import { useParams } from 'react-router-dom';
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import sleep from 'sleep-promise';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function Form() {
    const profileFilter = chooseProfileFilter();
    const { id } = useParams();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}governanceroom/samuneighborhoods/save`,
        endpointGetById: `${endpointBackend}governanceroom/samuneighborhoods/getById`,
        endpointGroups: `${endpointBackend}governanceroom/groups/getall`,
        endpointSubGroups: `${endpointBackend}governanceroom/subgroups/getall`,
        endpointNeighborhoods: `${endpointBackend}governanceroom/neighborhoods/getall`,
        urlGoBack: '/governanceroom/samuneighborhoods/list',
        pathView: '/governanceroom/samuneighborhoods/view'
    };

    const labels = {
        labelTitleEdit: 'Vincular Bairro SAMU',
        labelTitleView: 'Visualizar Bairro SAMU'
    };

    const render = async (values) => {
        const form = getForm(values);

        setFormContent(<></>);
        await sleep(1);
        setFormContent(
            <CustomFormContainer
                form={form}
                content={<CustomForm form={form} />}
            />
        );
    };

    // Nome e município vêm do arquivo do SAMU: só o vínculo é editável.
    // Grupo e sub-grupo são só filtros do bairro, não são salvos. Os três já
    // chegam presos ao município do registro (governance_room_geo_city_id).
    const getForm = (values) => ({
        hiddenValues: { id },
        fields: [
            {
                name: 'name',
                type: 'text',
                label: 'Bairro SAMU',
                readOnly: true,
                validations: { required: false },
                columnSize: 6
            },
            {
                name: 'city_state_name',
                type: 'text',
                label: 'Município',
                readOnly: true,
                validations: { required: false },
                columnSize: 6
            },
            {
                name: 'governance_room_group_id',
                type: 'select',
                label: 'Grupo',
                isClearable: true,
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGroups,
                    label: 'description',
                    value: 'id',
                    params: {
                        filter: {
                            profileFilter,
                            governance_room_city_id: values.governance_room_geo_city_id
                        }
                    }
                },
                handleChange: async (element, field, values) => {
                    values.governance_room_sub_group_id = '';
                    values.governance_room_neighborhood_id = '';
                    await render(values);
                },
                validations: { required: false },
                columnSize: 6
            },
            {
                name: 'governance_room_sub_group_id',
                type: 'select',
                label: 'Sub-Grupo',
                isClearable: true,
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointSubGroups,
                    label: 'description',
                    value: 'id',
                    params: {
                        filter: {
                            profileFilter,
                            governance_room_city_id: values.governance_room_geo_city_id,
                            governance_room_group_id: values.governance_room_group_id
                        }
                    }
                },
                handleChange: async (element, field, values) => {
                    values.governance_room_neighborhood_id = '';
                    await render(values);
                },
                validations: { required: false },
                columnSize: 6
            },
            {
                name: 'governance_room_neighborhood_id',
                type: 'select',
                label: 'Bairro',
                isClearable: true,
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointNeighborhoods,
                    label: 'description',
                    value: 'id',
                    params: {
                        filter: {
                            profileFilter,
                            governance_room_city_id: values.governance_room_geo_city_id,
                            governance_room_group_id: values.governance_room_group_id,
                            governance_room_sub_group_id: values.governance_room_sub_group_id
                        }
                    }
                },
                validations: { required: true },
                columnSize: 12
            }
        ],
        values,
        ...paths,
        ...labels
    });

    useEffect(() => {
        const load = async () => {
            await render(await Fetch.post(paths.endpointGetById, { id }));
        };
        load();
    }, []);

    return <div>{formContent}</div>;
}

export default Form;
